import type { ServerProviderSkill } from "@afar-research/contracts";

function titleCaseWords(value: string): string {
  const words: string[] = [];
  for (const segment of value.split(/[\s:_-]+/)) {
    if (segment.length === 0) continue;
    words.push(segment.charAt(0).toUpperCase() + segment.slice(1));
  }
  return words.join(" ");
}

export function formatProviderSkillDisplayName(
  skill: Pick<ServerProviderSkill, "name" | "displayName">,
): string {
  const displayName = skill.displayName?.trim();
  if (displayName) {
    return displayName;
  }
  return titleCaseWords(skill.name);
}

/** Text inserted into the composer when a skill is chosen from the Add menu. */
export function formatComposerSkillInsert(skillName: string): string {
  return `$${skillName} `;
}

export function formatProviderSkillInstallSource(
  skill: Pick<ServerProviderSkill, "path" | "scope" | "ownership">,
): string | null {
  if (skill.ownership === "app") {
    return "App";
  }

  const normalizedScope = skill.scope?.trim().toLowerCase();
  if (
    normalizedScope === "repo" ||
    normalizedScope === "project" ||
    normalizedScope === "workspace" ||
    normalizedScope === "local"
  ) {
    return "Project";
  }
  if (
    normalizedScope === "user" ||
    normalizedScope === "personal" ||
    normalizedScope === "system" ||
    normalizedScope === "admin"
  ) {
    return "Global";
  }
  if (normalizedScope) {
    return titleCaseWords(normalizedScope);
  }

  return null;
}
